export default __webpack_public_path__ + "static/media/logo.664f5bd5.png";